import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import { FindAMentor } from "../views/FindAMentor";
import { Projects } from "../views/Projects";
import { AboutMe } from "../views/AboutMe";
//import { SimpleCard } from "../views/Login";
import  SimpleCard from "./SimpleCard";

export const NavBar = () => (
  <Tabs>
    <TabList>
      <Tab>Find a Mentor</Tab>
      <Tab>About Me</Tab>
      <Tab>My Mentors</Tab>
      <Tab>LogIn</Tab>
    </TabList>

    <TabPanels>
      <TabPanel>
        <FindAMentor />
      </TabPanel>
      <TabPanel>
        <AboutMe />
      </TabPanel>
      <TabPanel>
        <p>My Mentors</p>
      </TabPanel>
      <TabPanel>
        <SimpleCard />
      </TabPanel>
    </TabPanels>
  </Tabs>
)